<template>
  <div id="prepare_question_view" class="prepare-question__view" :class="{'width-100': nameRouter === 'examAdd'}" ref="avatar">
    <div class="prepare-question__view__head">
      <div class="row">
        <div class="col-lg-5">
          <div class="prepare-question__view__head__wrap text-center">
            <p class="prepare-question__view__school font-sanpro-semibold font-size-26 primary-color-txt margin-0">
              {{ examInfo.schoolName }}
            </p>
            <p class="prepare-question__view__teacher font-sanpro-semibold font-size-18 primary-color-txt margin-0">
              Giáo viên: {{ examInfo.teacherName }}
            </p>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="prepare-question__view__head__wrap text-center">
            <p class="prepare-question__view__school font-sanpro-semibold font-size-26 primary-color-txt margin-0">
              Đề kiểm tra {{ renderTimeToDo() }}
            </p>
            <p class="prepare-question__view__subject font-sanpro-semibold font-size-26 primary-color-txt margin-0">
              Môn: {{ renderSubjects() }}
            </p>
            <p class="prepare-question__view__desc-time font-sanpro-semibold font-size-18 primary-color-txt margin-0">
              Thời gian làm bài: {{ renderTimeToDo() }}, không kể thời gian phát đề
            </p>
            <p class="prepare-question__view__desc-time font-sanpro-semibold font-size-18 primary-color-txt margin-0">
              Mã đề: {{ examInfo.code }}
            </p>
          </div>
        </div>
        <p class="prepare-question__view__note font-sanpro-light font-italic font-size-18 primary-color-txt text-center full-width">
          {{ examInfo.note }}
        </p>
      </div>
    </div>
    <div v-if="dataSource" class="prepare-question__view__body question-sample__list text-left">
      <div
        v-for="(item, index) of dataSource"
        :key="index"
        class="item"
        :class="`item__${item.type} layout-${item.layoutId}`"
      >
        <div class="item__head">
          <b class="primary-color-txt">{{ item.title }}</b><span v-if="item.title">:</span><div v-html="item.content"></div>
          <div v-if="item.imageUrl" class="item__head__img text-center margin-center ">
            <img 
              :src="item.isSample ? `${urlQuestionImg}/${item.imageUrl}` : `${appUrl}/${item.imageUrl}`"
              alt="Ảnh câu trả lời" 
            />
          </div>
        </div>
        <div class="item__body">
          <div class="answers">
            <div v-for="(ans, pos) of item.answers" :key="pos" class="item__answer">
              <div v-if="ans.imageUrl" class="item__answer__img text-center margin-center">
                <img 
                  :src="item.isSample ? `${urlQuestionImg}/${ans.imageUrl}` : `${appUrl}/${ans.imageUrl}`" 
                  alt="Ảnh câu trả lời" 
                />
              </div>
              <div class="item__answer__content">
                <b>{{ ans.code }}</b><span v-if="ans.code">.</span><div class="item__answer__content__detail" v-html="ans.content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { STORE_KEY } from './../../_store/constants'
import { TYPE_RADIO, TYPE_DOWN_ANSWER } from '@/modules/question/preview-question/_store/constants'
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionCorrectView',
  props: {
    dataSource: Array // array question
  },
  data () {
    return {
      questionDownAnswer: TYPE_DOWN_ANSWER,
      uploadUrl: APP_CONFIG.uploadUrl,
      appUrl: APP_CONFIG.appUrl,
      urlQuestionImg: APP_CONFIG.urlQuestionImg,
      cdnUrl: APP_CONFIG.cdnUrl,
      nameRouter: this.$route.name
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['examInfo', 'classesExam', 'subjectsExam', 'questionList', 'examTimesToDo'])
  },
  methods: {
    renderSubjects () {
      let indexSubjectCurr = this.subjectsExam.findIndex(sub => sub.subjectId === this.examInfo.subjectId)
      return indexSubjectCurr > -1 ? this.subjectsExam[indexSubjectCurr].name : ''
    },

    renderTimeToDo () {
      let indexTimeToDoCurr = this.examTimesToDo.findIndex(time => time.value === parseInt(this.examInfo.timeToDo))
      return indexTimeToDoCurr > -1 ? this.examTimesToDo[indexTimeToDoCurr].name : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.prepare-question__view{
  border: 1px solid #E5E5EA;
  width: 100%;
  margin: 50px auto 0 auto;
  &__head{
    margin-top: 4%;
  }
  &__body{
    width: 80%;
    margin: 0 auto;
  }
}
.width-100{
  width: 100% !important;
}

</style>